import { ModuleWithProviders, NgModule } from '@angular/core';
import { HttpLinkModule } from 'apollo-angular-link-http';
import { ApolloModule } from 'apollo-angular';
import { ApolloHelperService } from './apollo-helper.service';
import { InovaCommonGraphqlApi } from './common-api.service';


@NgModule({
  exports: [ApolloModule, HttpLinkModule],
  providers: [ApolloHelperService,InovaCommonGraphqlApi]
})
export class ApolloHelperModule {
  static forRoot(): ModuleWithProviders {
    return {
        ngModule: ApolloHelperModule
    };
  }
}


